import React, { useState } from 'react';
import useTrans from '@/hooks/useTrans';
import {get} from 'lodash';
import styles from './faq.module.css';

const Faq = ({ title, sub_title, arr_list_title_faq, arr_detail_fag }) => {
    const trans = useTrans();
    const [checkFaq, setCheckFaq] = useState(0);
    const [faqActive, setFaqActive] = useState('');

    const handleChangeFaq = (idx) => {
        setCheckFaq(idx);
        setFaqActive('');
    };

    const handleFaq = (index) => {
        if (index === faqActive) {
            setFaqActive('');
        } else {
            setFaqActive(index);
        } 
    };

    return (
        <div className={styles["tech_faq"]}>
        <div className={styles["tech_faq_container"]}>
          <div className={styles["tech_faq_content"]}>
            <h2 className={styles["sub-title"]}>{title}</h2>
            { sub_title && <h3 className='sub-title-2nd'>{sub_title}</h3> }
            
            <div>
              <div className={styles["tech_faq_list_title"]} data-aos='fade-right'>
                <div>
                  <h2>{trans.franchise.faq_list}</h2>
                  <ul className={styles["fr_list_faq"]}>
                    {arr_list_title_faq?.map((data, index) => {
                      return (
                        <li
                          className={
                            checkFaq === index ? styles["active_tech_faq"] : ''
                          }
                          onClick={() => handleChangeFaq(index)}
                        >
                          {data}
                        </li>
                      );
                    })}
                  </ul>
                </div>
                <img src='/assets/img/tech/faq.svg' alt='' />
              </div>
              <div className={styles["tech_faq_list_col"]}>
                <div className={styles["tech_faq_list_col_items"]} data-aos='fade-left'>
                    {arr_detail_fag[checkFaq]?.map((data, index) => {
                      return (
                        <div
                          className={styles["tech_faq_list_col_item"]}
                          onClick={() => handleFaq(index)}
                        >
                          <div className={styles["qjhabnqb"]}>
                            <h3
                              className={
                                index === faqActive ? styles['active_tech_faq'] : ''
                              }
                            >
                              {data.title}
                            </h3>

                            {index !== faqActive ? (
                              <img src='/assets/img/tech/plus.svg' alt='' />
                            ) : (
                              <img src='/assets/img/tech/minus.svg' alt='' />
                            )}
                          </div>
                          {index === faqActive && (
                            <div>
                              <p
                                dangerouslySetInnerHTML={{
                                  __html:
                                    get(trans, data.desc)
                                }}
                              ></p>
                            </div>
                          )}
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
};

export default Faq;